<template>
  <nav class="br-breadcrumb" aria-label="Navegação">
    <template v-if="parent">
      <router-link :to="parent.to" class="br-breadcrumb__parent">
        {{ parent.label }}
      </router-link>
      <v-icon size="16" class="br-breadcrumb__sep">mdi-chevron-right</v-icon>
    </template>
    <h1 class="br-breadcrumb__current">{{ current }}</h1>
  </nav>
</template>

<script lang="ts">
import { defineComponent, PropType } from "vue";

type BreadcrumbParent = {
  label: string;
  to: string;
};

export default defineComponent({
  name: "AppBreadcrumb",

  props: {
    current: { type: String, required: true },
    parent: { type: Object as PropType<BreadcrumbParent | null>, default: null },
  },
});
</script>

<style scoped lang="scss">
@import "@/assets/scss/design-system/tokens";

.br-breadcrumb {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: $br-space-1;
  min-width: 0;
}

.br-breadcrumb__parent {
  font-size: $br-font-size-sm;
  font-weight: 600;
  color: $br-muted;
  text-decoration: none;
  transition: color $br-transition-fast;

  &:hover {
    color: $br-brand;
  }
}

.br-breadcrumb__sep {
  color: $br-placeholder !important;
  flex-shrink: 0;
}

.br-breadcrumb__current {
  margin: 0;
  font-size: 1.25rem;
  font-weight: 800;
  color: $br-ink-soft;
  letter-spacing: -0.02em;
  line-height: 1.25;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
